export default __webpack_public_path__ + "media/images/logo-symbol-icon-8448440a2be11010a4ab92c981a5c98f.svg";